import { InjectionToken } from '@angular/core';
import { DateFormatValue } from '../classes/date-format-value';

export const DATE_FORMAT_VALUE_TOKEN = new InjectionToken<DateFormatValue>('dateFormat ');
